<template>
  <ag-select
    :id="id"
    :value="value"
    :options="categories"
    @change="$emit('change', $event)"
  />
</template>

<script>
  export default {
    name: "CategorySelect",
    props: {
      id: String,
      value: String,
      withEmptySelection: Boolean
    },
    data: () => ({
      categories: []
    }),
    async mounted() {
      try {
        const categories = await this.$service.recipe.findAllCategories();

        this.categories = categories.map(category => {
          return {
            id: category.key,
            label: category.name
          }
        });

        if(this.withEmptySelection) {
          const emptyState = {
            id: this.$constant.categories.ALL_CATEGORIES_KEY,
            label: this.$constant.categories.ALL_CATEGORIES_NAME
          };

          this.categories = [
            emptyState,
            ...this.categories
          ];
        }
        
      } catch (e) {
        console.error(`Error loading categories`, e);
      }
    },
  };
</script>

<style scoped lang="scss"></style>
